import RadioButton from "../../components/RadioButton";
import "../css/GODEXLabel.css";

export default function GODEXLabel({ n, index, labelType, onSelect }) {
  const isFirstRow = index < 3;
  return (
    <div
      className={`godexlabel-container${isFirstRow ? " godexlabel-container--first-row" : ""}`}
    >
      <img
        src={`/images/devices/${n}.png`}
        alt={`Tipo ${n}`}
        className={`godexlabel-img ${isFirstRow ? "godexlabel-img--first-row" : "godexlabel-img--second-row"}`}
        onClick={() => onSelect(n)}
      />
      <RadioButton active={labelType === n} onClick={() => onSelect(n)} />
    </div>
  );
}
